@if (displayHeader) {
  <header class="header bg-white">
    <div class="header-wrapper sticky z-1 shadow-2 p-x-7">
      <nav class="navigation flex flex-wrap align-items-center justify-content-between">
        <ul class="flex gap-1 align-items-center list-none">
          @if (logoImage) {
            <li class="logo-wrapper flex">
              <a
                class="flex"
                target="_blank"
                [href]="!!isEventSelected ? exhibitionSettings?.headerLogoLink : operatorsSettings?.headerLogoLink"
                [ngClass]="{
                  'pointer-events-none': !!isEventSelected
                    ? !exhibitionSettings?.isHeaderLogoLinkVisible
                    : !operatorsSettings?.isHeaderLogoLinkVisible
                }"
              >
                <img class="operator-logo p-y-2" alt="" role="presentation" [src]="logoImage" />
              </a>
            </li>
          }

          @if (ageRating$ | async; as ageRating) {
            <li>
              <app-age-rating [rating]="ageRating" [adjustPositions]="{ top: '10px', right: '5px' }" />
            </li>
          }
        </ul>

        <ul class="list-none">
          <li class="uppercase p-y-2">
            <ls-dropdown
              [options]="supportedLanguages$ | async"
              [showClear]="false"
              [required]="true"
              [selectedOption]="currentLanguage"
              (selectedOptionChange)="onChangeLanguage($event)"
            />
          </li>
        </ul>
      </nav>
    </div>
  </header>
}
